/* eslint-disable react/style-prop-object */
import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";

// hooks and utilities
import { formatMoney } from "common/format";
import { useLogOut } from "components/auth/LogOut";
import useEventListener from "hooks/useEventListener";
import { useTranslate, useTranslateFunction } from "lang/Translate";

//components
import Tooltip from "components/common/tooltip/Tooltip";

//css
import "./Navbar.scoped.scss";

//api
import api from "api/api";

const Navbar = () => {
	const [{ tester: isTester = false }, setUserInfo] = useState({});
	const [width, setWidth] = useState(window.innerWidth);
	const [formattedMoney, setFormattedMoney] = useState("0 USD");
	const { money, points } = useSelector(state => state.groupInfo);
	const boxTab = useSelector(store => store.box.tab);

	const { signOut, loading: signOutLoading } = useLogOut();

	const dispatch = useDispatch();
	const translate = useTranslateFunction();
	const c = "Navbar";

	const getUserInfo = async () => {
		try {
			const { data } = await axios.get(`${api}/user/tester`);
			setUserInfo(data);
		} catch (err) {
			console.error(err);
		}
	};

	const showBox = tabId => {
		if (tabId === undefined) return;
		if (boxTab === tabId) {
			dispatch({ type: "CHANGE_BOX_TAB", tab: null });
			return;
		}

		dispatch({ type: "CHANGE_BOX_TAB", tab: tabId });
	};

	useEffect(() => setFormattedMoney(formatMoney(money)), [money]);
	useEffect(() => {
		getUserInfo();
	}, []);

	useEventListener(window, "resize", useCallback(() => setWidth(window.innerWidth), []));

	return (
		<div className={width > 500 ? "navbar" : "navbar navbar--responsive"}>
			<div className="navbar__buget">
				<div className="money" title={useTranslate({ component: "Navbar", Tkey: "MONEY" })}>
					<label>{useTranslate({ component: "Navbar", Tkey: "MONEY" })}</label>
					<span>{formattedMoney}</span>
				</div>
				<div className="points" title={useTranslate({ component: "Navbar", Tkey: "POINTS" })}>
					<label>{useTranslate({ component: "Navbar", Tkey: "POINTS" })}</label>
					<span>{points}</span>
				</div>
			</div>
			{width > 500 ? <></> : <input type="checkbox" className="fas fa-ellipsis-v more" />}
			<div className="navbar__icons">
				<Tooltip text={translate("NOTIFICATIONS", c)} compact={true} position="bottom" theme="dark-li">
					<i className="fas fa-bell icon" onClick={() => showBox(undefined)} />
				</Tooltip>

				<Tooltip text={translate("MAIL", c)} compact={true} position="bottom" theme="dark-li">
					<i className="fas fa-envelope icon" />
				</Tooltip>

				<div className="separator" />
				{isTester && (
					<Tooltip text={translate("ADMIN_TOOLS", c)} compact={true} position="bottom" theme="dark-li">
						<i className="fas fa-user-gear icon" onClick={() => showBox(1)} />
					</Tooltip>
				)}
				{isTester && <div className="separator" />}

				<Tooltip text={translate("RESEARCH", c)} compact={true} position="bottom" theme="dark-li">
					<i className="fas fa-flask icon" onClick={() => window.showOverlay("research")} />
				</Tooltip>

				<Tooltip text={translate("PROFILE", c)} compact={true} position="bottom" theme="dark-li">
					<i className="fas fa-user icon" onClick={() => window.showOverlay("profile")} />
				</Tooltip>

				<Tooltip text={translate("ABOUT", c)} compact={true} position="bottom" theme="dark-li">
					<i className="fas fa-question-circle icon" onClick={() => window.showOverlay("about")} />
				</Tooltip>

				<Tooltip text={translate("LOGOUT", c)} compact={true} position="bottom" theme="dark-li">
					<div className="icon" onClick={signOutLoading ? () => {} : signOut}>
						{signOutLoading ? (
							<div className="ball-clip-rotate" style={{ display: "grid", placeContent: "center" }}>
								<div />
							</div>
						) : (
							<i className="fas fa-sign-out-alt icon" />
						)}
					</div>
				</Tooltip>
			</div>
		</div>
	);
};

export default Navbar;
